// 抖店相关接口
import { sendPost } from '../http.js'

const api = {
	'ddXxxxxxAPI': '/ddxxxxx', // 范例
    'getDdClassCateAPI': '/doushop/category', // 获取抖店课程分类列表
    'getDdClassCateTopAPI': '/doushop/parent/category', // 获取抖店课程顶级分类
    'getCatePropertiesAPI': '/doushop/category/property', // 获取抖店分类属性
    'createEditDdGoodsAPI': '/doushop/product/save', // 创建/编辑抖店课程
    'getDdGoodsListAPI': '/doushop/product_list', // 获取抖店课程列表
    'ddClassGroundingAPI': '/doushop/product/status', // 抖店课程上下架
    'getDdGoodsDetailAPI': '/doushop/product/info', // 获取商品详情
    'changeDdGoodsStockAPI': '/doushop/product/stock', // 修改商品库存
    'getDdCanSelectClassListAPI': '/user/user/productlist', // 获取创建小店课程时，可选择的课程
    'getDdRefundListAPI': '/user/order/refund', // 获取退款订单列表
    'cancelVerifyAPI': '/doushop/order/cancel/verify', // 取消核销
}

export default {
    ddXxxxxxAPI(params) {
        return sendPost(api.ddXxxxxxAPI, params)
    },
    getDdClassCateAPI(params) {
        return sendPost(api.getDdClassCateAPI, params)
    },
    getDdClassCateTopAPI(params) {
        return sendPost(api.getDdClassCateTopAPI, params)
    },
    getCatePropertiesAPI(params) {
        return sendPost(api.getCatePropertiesAPI, params)
    },
    createEditDdGoodsAPI(params) {
        return sendPost(api.createEditDdGoodsAPI, params)
    },
    getDdGoodsListAPI(params) {
        return sendPost(api.getDdGoodsListAPI, params)
    },
    ddClassGroundingAPI(params) {
        return sendPost(api.ddClassGroundingAPI, params)
    },
    getDdGoodsDetailAPI(params) {
        return sendPost(api.getDdGoodsDetailAPI, params)
    },
    changeDdGoodsStockAPI(params) {
        return sendPost(api.changeDdGoodsStockAPI, params)
    },
    getDdCanSelectClassListAPI(params) {
        return sendPost(api.getDdCanSelectClassListAPI, params, 'post', {
            'come-from': 1
        })
    },
    getDdRefundListAPI(params) {
        return sendPost(api.getDdRefundListAPI, params)
    },
    cancelVerifyAPI(params) {
        return sendPost(api.cancelVerifyAPI, params)
    },
}